var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgShareArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_2388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4101 4.0329L15.6101 4.02757C15.6072 3.36899 15.074 2.83583 14.4154 2.83291L14.4101 4.0329ZM13.243 11.4483C13.2459 12.1111 13.7856 12.6459 14.4483 12.643C15.1111 12.64 15.6459 12.1004 15.643 11.4377L13.243 11.4483ZM7.00533 2.80001C6.34259 2.79707 5.80295 3.33194 5.80001 3.99467C5.79707 4.65741 6.33194 5.19705 6.99467 5.19999L7.00533 2.80001ZM13.2101 4.03823L13.243 11.4483L15.643 11.4377L15.6101 4.02757L13.2101 4.03823ZM6.99467 5.19999L14.4048 5.23289L14.4154 2.83291L7.00533 2.80001L6.99467 5.19999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14.631,
    x2: 13.3029,
    y2: 5.32809,
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_2388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "currentColor"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgShareArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-arrow.6a998e19e6e899414af6fbf1d3f2b2c7.svg";